<template>
  <ca-tr-collapse
    v-if="report.children && report.children.length"
    initial-collapsed>
    <ca-td>{{ report.name }}</ca-td>
    <template slot="nested">
      <report-center-table-row
        v-for="(childReport, index) in report.children"
        slot="nested"
        :key="index"
        :report="childReport">
      </report-center-table-row>
    </template>
  </ca-tr-collapse>
  <ca-tr-nested
    v-else
    slot="nested"
    @click.native="openReportModal(report)">
    <ca-td>{{ report.name }}</ca-td>
  </ca-tr-nested>
</template>

<script>
import ReportCenterModal from '../report-center-modal/ReportCenterModal.vue';

export default {
  name: 'ReportCenterTableRow',
  props: {
    report: {
      type: Object,
      required: true,
    },
  },
  computed: {
    currentCollapseLevel() {
      return this.$parent.currentCollapseLevel || 0;
    },
  },
  methods: {
    openReportModal(report) {
      this.$dialogModal(ReportCenterModal, {
        props: {
          report,
        },
      }).open();
    },
  },
};
</script>
